import React from "react";
import MessageItem from "./MessageItem";
import WelcomeScreen from "./WelcomeScreen";

function LoadingIndicator() {
  return (
    <div className="flex gap-3 items-center mt-4 text-sm text-gray-500">
      <div className="pim-assistant-avatar">
        <svg
          className="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
          />
        </svg>
      </div>
      <span className="inline-flex gap-1" aria-busy aria-label="Đang kết nối">
        <span className="inline-block h-1.5 w-1.5 rounded-full bg-emerald-500/60 msg-list-dot" style={{ animationDelay: "0s" }} />
        <span className="inline-block h-1.5 w-1.5 rounded-full bg-emerald-500/60 msg-list-dot" style={{ animationDelay: "0.18s" }} />
        <span className="inline-block h-1.5 w-1.5 rounded-full bg-emerald-500/60 msg-list-dot" style={{ animationDelay: "0.36s" }} />
      </span>
      <style>{`.msg-list-dot{animation:msgListDotPulse 1.05s ease-in-out infinite}@keyframes msgListDotPulse{0%,80%,100%{opacity:.35;transform:translateY(0)}40%{opacity:1;transform:translateY(-3px)}}`}</style>
    </div>
  );
}

function ErrorMessage({ error }) {
  return (
    <div className="flex justify-center mt-4">
      <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-2.5 rounded-xl text-sm flex items-center gap-2">
        <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
        </svg>
        {error}
      </div>
    </div>
  );
}

function MessageList({
  messages,
  isLoading,
  error,
  messagesScrollRef,
  formatTime,
  onSelectSuggestion,
  editingMessageId,
  onStartEdit,
  onCancelEdit,
  onSaveEdit,
  onRegenerate,
  onBranch,
  onFeedback,
  onSaveMistake,
  onSimilarProblems,
  onFormulaCard,
  learningMode,
  modeGroup,
}) {
  const isEmpty = messages.length === 0;

  return (
    <div
      ref={messagesScrollRef}
      className="flex-1 min-h-0 overflow-y-auto overscroll-y-contain"
      style={{ minHeight: 0, WebkitOverflowScrolling: "touch" }}
    >
      <div className={`pim-chat-container ${isEmpty ? "h-full flex flex-col" : "pt-6 pb-3"}`}>
        {isEmpty ? (
          <div className="flex-1 flex items-center justify-center">
            <WelcomeScreen onSelectSuggestion={onSelectSuggestion} modeGroup={modeGroup} />
          </div>
        ) : (
          <div className="space-y-6">
            {messages.map((message) => (
              <MessageItem
                key={message.id}
                message={message}
                formatTime={formatTime}
                editingMessageId={editingMessageId}
                onStartEdit={onStartEdit}
                onCancelEdit={onCancelEdit}
                onSaveEdit={onSaveEdit}
                onRegenerate={onRegenerate}
                onBranch={onBranch}
                onFeedback={onFeedback}
                isLoading={isLoading}
                onSaveMistake={onSaveMistake}
                onSimilarProblems={onSimilarProblems}
                onFormulaCard={onFormulaCard}
                learningMode={learningMode}
              />
            ))}
          </div>
        )}

        {isLoading && !messages.some((m) => m.role === "assistant" && m.streaming) && <LoadingIndicator />}
        {error && <ErrorMessage error={error} />}
      </div>
    </div>
  );
}

export default MessageList;
